import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import HistoryIcon from '@mui/icons-material/History';
import QuestionMarkOutlinedIcon from '@mui/icons-material/QuestionMarkOutlined';
import { useAnchorMenu } from 'hooks';
import { SidebarEmergencyItem } from 'features/emergency';
import useTheme from '@mui/system/useTheme';
const SettingsNavItem = ({
  to,
  title,
  icon,
  onClose,
}: {
  to: string;
  title: string;
  icon: ReactNode;
  onClose?: () => void;
}) => {
  const t = useTheme();
  return (
    <MenuItem onClick={onClose}>
      <Link
        to={to}
        style={{
          display: 'flex',
          alignItems: 'center',
          color: t.palette.primary.main,
          textDecoration: 'none',
          width: '100%',
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <Typography sx={{ fontSize: '0.875rem' }}>{title}</Typography>
      </Link>
    </MenuItem>
  );
};

const SettingsNav = () => {
  const { isOpen, anchor, handleOpenMenu, handleCloseMenu } = useAnchorMenu();

  return (
    <>
      <Button
        sx={(t) => ({ color: t.palette.text.secondary })}
        id="settings-item-button"
        aria-controls={isOpen ? 'settings-item-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        variant="text"
        disableElevation
        disableRipple
        disableTouchRipple
        onClick={handleOpenMenu}
      >
        <ViewCompactIcon sx={{ fontSize: 24 }} />
      </Button>
      <Menu
        id="settings-item-menu"
        slotProps={{
          paper: {
            sx: {
              width: 200,
            },
          },
        }}
        elevation={8}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorEl={anchor}
        open={isOpen}
        onClose={handleCloseMenu}
      >
        <SettingsNavItem
          onClose={handleCloseMenu}
          to={'/rule-history'}
          title="History"
          icon={<HistoryIcon fontSize="small" color="primary" sx={{ mr: 1 }} />}
        />
        <SettingsNavItem
          onClose={handleCloseMenu}
          to={'/logs'}
          title="Logs"
          icon={<QuestionMarkOutlinedIcon fontSize="small" color="primary" sx={{ mr: 1 }} />}
        />
        <SettingsNavItem
          onClose={handleCloseMenu}
          to={'/users'}
          title="Users"
          icon={<AccountCircleOutlinedIcon fontSize="small" color="primary" sx={{ mr: 1 }} />}
        />
        <SettingsNavItem
          onClose={handleCloseMenu}
          to={'/networks'}
          title="Networks"
          icon={<AlternateEmailIcon fontSize="small" color="primary" sx={{ mr: 1 }} />}
        />
        <SidebarEmergencyItem onClose={handleCloseMenu} />
      </Menu>
    </>
  );
};

export default SettingsNav;
